// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"ContentTab_placeholder__15K4O","text":"ContentTab_text__cRK_Z"};